import { render, staticRenderFns } from "./LastTicketsWrapper.vue?vue&type=template&id=6390eff0&scoped=true"
import script from "./LastTicketsWrapper.vue?vue&type=script&lang=js"
export * from "./LastTicketsWrapper.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsWrapper.vue?vue&type=style&index=0&id=6390eff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6390eff0",
  null
  
)

export default component.exports